<template lang="pug">
	section.container-fluid.animated.fadeIn.pt-3

		b-alert.mb-3(show v-if="$route.hash === '#just-created'" variant="success")
			| Вы были успешно зарегистрированы!

		b-card.mb-3(no-body v-if="items.length")
			b-breadcrumb.mb-0(:items="items")

		options(v-if="optionsArr.length" :options="optionsArr")

		b-alert.mt-4.mb-4(show v-else)
			| На данный момент дополнительных действий от Вас не требуется.
			| Если у Вас возникли вопросы Вы можете связаться с нами по телефону
			a(:href="`tel:${phone}`")  {{ phone }}

		b-card.mb-3(no-body id="tabs")
			b-tabs.info-tabs(v-model="page.participant.tabIndex" card)

				b-tab(title='Информация о регистрации' v-if="myParticipant.data.event.category.slug === 'conferences' && (!isSelectionStage || myParticipant.data.children.length !== 0 )")
					infoTab

				b-tab(title='Моя программа' v-if="isSelectionStage && myParticipant.data.event.session_count")
					scheduleTab

				b-tab(v-if="myParticipant.data.event.can_add_session" title='Мой доклад')
					lecturesTab
				b-tab(v-if="isSelectionStage && availableHalls.length>0" title='Мои встречи')
					meetingsTab

				b-tab(title='Описание мероприятия')
					div(v-html="myParticipant.data.event.description") {{ myParticipant.data.event.description }}
</template>

<script>
	import { mapActions, mapState } from 'vuex'
	import options from './components/options.vue'

	import infoTab from './tabs/infoTab'
	import lecturesTab from './tabs/lecturesTab'
	import scheduleTab from './tabs/scheduleTab'
	import meetingsTab from './tabs/meetings'
	import smoothScrollToEl from "../../MIXINS/smoothScrollToEl";

	export default {
		name: 'Registrations',
		components: {
			options,

			infoTab,
			lecturesTab,
			scheduleTab,
			meetingsTab,
		},
		mixins: [
			smoothScrollToEl,
		],
		data: () => ({
			transition: 'slide-right',
			phone: '+7 (495) 644-06-08',
		}),
		computed: {
			...mapState(['myParticipant', 'page']),
			...mapState({
				halls:state=>state.event.halls,
			}),

			isSelectionStage(){ return this.myParticipant.data.stage.order>=this.myParticipant.data.event.selection_stage.order },

			getStages(){ return this.myParticipant.data.event.stages } ,
			activeStage(){ return this.myParticipant.data.stage },

			optionsArr(){ return (this.activeStage.option ? this.activeStage.option.split('') : []) },

			items(){
				return !this.activeStage
					? []
					: (this.getStages || []).reduce( (acc, { title:text, id }) =>
						[...acc, {text, active:(id!==this.activeStage.id)}],[])
			},
			availableHalls(){

				return this.halls.data.filter(item=>item.available_for_meeting) || [];
			},
		},
		methods: {
			...mapActions('myParticipant/nested/lectures', ['getPpntLectures']),
			...mapActions('event/nested/meetings', ['getEventMeetings']),
			...mapActions('event/nested/halls', ['getEventHalls']),

			async switchTab(num){
				await this.$store.dispatch('changeTab', num);
				await this.smoothScrollToEl('#tabs', 65);
			},

		},
		beforeMount(){
			this.$store.dispatch('getPpntLectures', { id:this.myParticipant.data.id });
			this.$store.dispatch('getEventMeetings',{id:this.myParticipant.data.event.id});
			this.$store.dispatch('getEventHalls',{id:this.myParticipant.data.event.id});
			console.log(this.myParticipant.data);
		},
		created(){
			if (this.$route.query.tab){
				this.switchTab(this.$route.query.tab)
			}

		}
	}
</script>
